import React, { FC } from "react";

import Tooltip from "antd/es/tooltip";
import { defineMessages, useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import { VISIBLE_TERRITORIES_LIMIT } from "@app/util/consts";

import styles from "./Footer.module.scss";

const messages = defineMessages({
  cancel: {
    id: "map.layer.boundaries.territories.filterModal.footer.cancel",
    defaultMessage: "Cancel",
    description: "Cancel button in Footer of the Filter Territories modal",
  },
  count: {
    id: "map.layer.boundaries.territories.filterModal.footer.count",
    defaultMessage:
      "{selected} / {total} {total, plural, one {territory selected} other {territories selected}}",
    description: "Selected territories text in Footer of the Filter Territories modal",
  },
  deselectAll: {
    id: "map.layer.boundaries.territories.filterModal.footer.deselectAll",
    defaultMessage: "Deselect all",
    description: "Deselect All button in Footer of the Filter Territories modal",
  },
  disabledTooltip: {
    id: "map.layer.boundaries.territories.filterModal.footer.ok.disabledTooltip",
    defaultMessage:
      "No more than {count} {count, plural, one {territory} other {territories}} can be shown on the map at once",
    description: "Ok button tooltip in Footer of the Filter Territories modal",
  },
  selectAll: {
    id: "map.layer.boundaries.territories.filterModal.footer.selectAll",
    defaultMessage: "Select all",
    description: "Select All button in Footer of the Filter Territories modal",
  },
  show: {
    id: "map.layer.boundaries.territories.filterModal.footer.ok",
    defaultMessage: "Show ({count})",
    description: "Cancel button in Footer of the Filter Territories modal",
  },
});

export interface FooterProps {
  onCancel?: () => void;
  onDeselectAll?: () => void;
  onOk?: () => void;
  onSelectAll?: () => void;
  selected: number;
  total: number;
}

const Footer: FC<FooterProps> = ({
  onCancel,
  onDeselectAll,
  onOk,
  onSelectAll,
  selected,
  total,
}) => {
  const intl = useIntl();

  const okDisabled = selected > VISIBLE_TERRITORIES_LIMIT;

  return (
    <div className={styles.container}>
      <div className={styles.selection}>
        <div>{intl.formatMessage(messages.count, { selected, total })}</div>
        <Button className={styles.toggleButton} onClick={onSelectAll} size="small" type="filled">
          {intl.formatMessage(messages.selectAll)}
        </Button>
        <Button className={styles.toggleButton} onClick={onDeselectAll} size="small" type="default">
          {intl.formatMessage(messages.deselectAll)}
        </Button>
      </div>
      <div className={styles.buttons}>
        <Button onClick={onCancel} type="default">
          {intl.formatMessage(messages.cancel)}
        </Button>
        <Tooltip
          title={intl.formatMessage(messages.disabledTooltip, { count: VISIBLE_TERRITORIES_LIMIT })}
          trigger={okDisabled ? ["hover"] : []}
        >
          {/* inner div is needed because otherwise tooltip isn't shown for a disabled button */}
          <div>
            <Button disabled={okDisabled} onClick={onOk} type="primary">
              {intl.formatMessage(messages.show, { count: selected })}
            </Button>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default Footer;
